import React from "react";
import ReactDOM from "react-dom";
import "./assets/fonts/Futura Round Cond Extra Bold.ttf";
import "./assets/fonts/Futura Round Cond Light.ttf";
import "./assets/fonts/Futura Round Cond Medium.ttf";
import "./index.css";
import App from "./App";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
